
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import Login from "../Pages/Auth/Login";
import Register from "../Pages/Auth/Register";
import BookShip from "../Pages/Home/BookShip";
import Requests from "../Pages/Home/Requests";
import Request from "../Pages/Home/Request";
import EditProfile from "../Pages/Profile/EditProfile";

const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 1,
        path: "/destination/:id",
        component: <Home />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/register",
        component: <Register />,
    },
    {
        pageId : 4,
        path: "/book-shipment",
        component: <BookShip />,
    },
    {
        pageId : 5,
        path: "/requests",
        component: <Requests />,
    },
    {
        pageId : 6,
        path: "/request/:id",
        component: <Request />,
    },
    {
        pageId : 6,
        path: "/edit-profile",
        component: <EditProfile />,
    },

];
export default appRoutes;
